export default function(BotaoSeguir){
    return(
        <button className="btnSeguir">Seguir</button>
    )
}